import { render, staticRenderFns } from "./AddContentPhotoComponent.vue?vue&type=template&id=7b31c248&scoped=true"
import script from "./AddContentPhotoComponent.vue?vue&type=script&lang=js"
export * from "./AddContentPhotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b31c248",
  null
  
)

export default component.exports